import React from "react";
import { MultipleChoice, MultipleSelection, Question, Rating, Scale, YesNo } from "../types";
import MultipleChoiceOptionsPreviewDisplay from "./MultipleChoiceOptionsPreviewDisplay";
import MultipleSelectionOptionsPreviewDisplay from "./MultipleSelectionOptionsPreviewDisplay";
import ScalePreviewDisplay from "./ScalePreviewDisplay";
import RatingPreviewDisplay from "./RatingPreviewDisplay";
import YesNoPreviewDisplay from "./YesNoPreviewDisplay";
import ShortResponsePreviewDisplay from "./ShortResponsePreviewDisplay";
import DropdownSelectionOptionsPreviewDisplay from "./DropdownSelectionOptionsPreviewDisplay";

interface QuestionPreviewDisplayProps {
    question: Question;
}

export default (props: QuestionPreviewDisplayProps) => {

    const { question } = props;

    return (
        <div className="flex flex-col w-11/12 min-h-96  p-5 border border-stone-500 rounded-3xl shadow-black shadow-md capitalize">
            {question.type === 'Multiple Choice' && (
                <div>
                    <MultipleChoiceOptionsPreviewDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleChoice).options} />
                </div>
            )}
            {question.type === 'Multiple Selection' && (
                <div>
                    <MultipleSelectionOptionsPreviewDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleSelection).options} />
                </div>
            )}
            {
                question.type === 'Dropdown Selection' && (
                    <div>
                        <DropdownSelectionOptionsPreviewDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleSelection).options} />
                    </div>
            )}
            {question.type === 'Short Response' && (
                <div>
                    <ShortResponsePreviewDisplay question={question} questionText={question.questionText} options={[]}/>
                </div>
            )}
            {question.type === 'Scale' && (
                <div>
                    <ScalePreviewDisplay question={question} questionText={question.questionText} questionBody={(question.questionBody as Scale)} />
                </div>
            )}
            {question.type === 'Rating' && (
                <div>
                    <RatingPreviewDisplay question={question} questionText={question.questionText} questionBody={(question.questionBody as Rating)} />
                </div>
            )}
            {question.type === 'YesNo' && (
                <div>
                    <YesNoPreviewDisplay question={question} questionText={question.questionText} options={(question.questionBody as YesNo).options} />
                </div>
            )}
        </div>
    )
}